import { object, string } from 'yup'
import { PickupAddressSchema } from './PickupAddress.schema'

export const pickupSchema = (states = [], cities = []) =>
  object().shape({
    name: string().required('É necessário preencher o nome do local de embarque'),
    addressInfo: object().shape(PickupAddressSchema(states, cities))
  })
